/* Rithu Karnika — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Rotating announcement bar ---------------------------------------- */
  function initAnnouncement(root) {
    var msgs = root.querySelectorAll('.announcement__msg');
    if (msgs.length < 2) return;

    var i = 0;
    var timer = null;

    function show(next) {
      msgs[i].classList.remove('is-active');
      i = (next + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }

    function start() {
      if (reduceMotion) return;
      var every = parseInt(root.dataset.interval, 10) || 5000;
      timer = setInterval(function () { show(i + 1); }, every);
    }

    function restart() { clearInterval(timer); start(); }

    root.querySelectorAll('[data-announcement-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        show(i + (btn.dataset.announcementNav === 'next' ? 1 : -1));
        restart();
      });
    });

    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', start);
    start();
  }

  /* --- Hero slideshow ---------------------------------------------------- */
  function initHero(root) {
    var slides = root.querySelectorAll('.hero__slide');
    var dots = root.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;

    var i = 0;
    var timer = null;

    function go(next) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (next + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }

    function start() {
      if (reduceMotion || root.dataset.autoplay !== 'true') return;
      var every = parseInt(root.dataset.interval, 10) || 6000;
      timer = setInterval(function () { go(i + 1); }, every);
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        go(index);
        clearInterval(timer);
        start();
      });
    });

    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', start);
    start();
  }

  /* --- Mobile navigation drawer ------------------------------------------ */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () { drawer.setAttribute('hidden', ''); }, 350);
      if (lastFocus) lastFocus.focus();
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* --- Product variant switching ----------------------------------------- */
  function initVariants(root) {
    var data = root.querySelector('[data-variants]');
    if (!data) return;

    var variants = JSON.parse(data.textContent);
    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var submit = root.querySelector('[data-add-button]');
    var selects = root.querySelectorAll('[data-option-index]');

    function money(cents) {
      var format = root.dataset.moneyFormat || '{{amount}}';
      var amount = (cents / 100).toFixed(2);
      return format.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function update() {
      var chosen = [];
      selects.forEach(function (s) { chosen[parseInt(s.dataset.optionIndex, 10)] = s.value; });

      var match = variants.find(function (v) {
        return v.options.every(function (opt, n) { return opt === chosen[n]; });
      });

      if (!match) {
        submit.disabled = true;
        submit.textContent = submit.dataset.labelUnavailable;
        return;
      }

      idField.value = match.id;

      if (priceEl) {
        if (match.compare_at_price > match.price) {
          priceEl.innerHTML = '<s>' + money(match.compare_at_price) + '</s>' +
                              '<span class="on-sale">' + money(match.price) + '</span>';
        } else {
          priceEl.textContent = money(match.price);
        }
      }

      var barPrice = document.querySelector('[data-bar-price]');
      if (barPrice) {
        barPrice.innerHTML = match.compare_at_price > match.price
          ? '<span class="on-sale">' + money(match.price) + '</span>'
          : money(match.price);
      }

      var barVariant = document.querySelector('[data-bar-variant]');
      if (barVariant) barVariant.textContent = match.options.join(' / ');

      selects.forEach(function (sel) {
        var dot = root.querySelector('[data-swatch-for="' + sel.dataset.optionIndex + '"]');
        if (!dot) return;
        var colour = sel.options[sel.selectedIndex].dataset.swatch;
        if (colour) dot.style.background = colour;
      });
      submit.disabled = !match.available;
      submit.textContent = match.available ? submit.dataset.labelAdd : submit.dataset.labelSoldOut;

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  }

  /* --- Cart quantity steppers --------------------------------------------- */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (widget) {
      var input = widget.querySelector('input');
      widget.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          var next = Math.max(0, parseInt(input.value, 10) + step);
          input.value = next;
          input.form.submit();
        });
      });
    });
  }

  /* --- Horizontal rails (collection grid on mobile) ---------------------- */
  function initRail(scope) {
    var rail = scope.querySelector('[data-rail]');
    var prev = scope.querySelector('[data-rail-prev]');
    var next = scope.querySelector('[data-rail-next]');
    if (!rail || !prev || !next) return;

    var autoTimer = null;
    var INTERVAL = 3000;          /* auto-advance every 3 seconds */
    var PAUSE    = 6000;          /* pause this long after manual interaction */

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth * 0.5;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 16;
      return first.getBoundingClientRect().width + gap;
    }

    function atEnd() {
      return rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }

    function advance() {
      if (atEnd()) {
        /* Loop: jump back to the start smoothly */
        rail.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      } else {
        rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    function startAuto(delay) {
      clearInterval(autoTimer);
      if (reduceMotion) return;
      autoTimer = setInterval(advance, delay || INTERVAL);
    }

    function pauseAuto() {
      clearInterval(autoTimer);
      startAuto(PAUSE);   /* restart with longer delay after touch */
    }

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      scope.classList.toggle('is-static', max <= 0);
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      pauseAuto();
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      pauseAuto();
    });

    /* Pause on touch so the user can browse freely */
    rail.addEventListener('touchstart', function () { clearInterval(autoTimer); }, { passive: true });
    rail.addEventListener('touchend',   pauseAuto, { passive: true });

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);

    sync();
    startAuto();
  }

  /* --- Shoppable image hotspots ------------------------------------------ */
  function initHotspots(scope) {
    var spots = scope.querySelectorAll('[data-hotspot]');
    if (!spots.length) return;

    function closeAll(except) {
      spots.forEach(function (s) {
        if (s !== except) s.setAttribute('aria-expanded', 'false');
      });
    }

    spots.forEach(function (spot) {
      spot.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = spot.getAttribute('aria-expanded') === 'true';
        closeAll(spot);
        spot.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    document.addEventListener('click', function () { closeAll(null); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  }

  /* --- Sticky panel ------------------------------------------------------
     A panel taller than the viewport would stick with its bottom out of
     reach. Lowering `top` by the overflow lets the reader get to the end;
     the sticky container still releases it at the end of the grid. */
  function initSticky(panel) {
    function measure() {
      if (window.innerWidth < 990) {
        panel.style.removeProperty('--sticky-top');
        return;
      }
      var headroom = 80;
      var overflow = panel.offsetHeight + headroom - window.innerHeight;
      panel.style.setProperty('--sticky-top', overflow > 0 ? (headroom - overflow) + 'px' : headroom + 'px');
    }

    measure();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(panel);
  }

  /* --- Quantity stepper on the product page ------------------------------- */
  function initProductQty(scope) {
    scope.querySelectorAll('[data-qty-product]').forEach(function (widget) {
      var input = widget.querySelector('input');
      widget.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          input.value = Math.max(1, parseInt(input.value, 10) + step);
        });
      });
    });
  }

  /* --- Sticky product bar -------------------------------------------------
     Watches the buy controls. Once they leave the top of the viewport the
     bar slides in; it retreats as soon as they come back. */
  function initStickyBar(scope) {
    var bar = scope.querySelector('[data-sticky-bar]');
    if (!bar) return;

    var anchor = scope.querySelector('.product__buttons') ||
                 scope.querySelector('[data-add-button]');
    if (!anchor) return;

    bar.removeAttribute('hidden');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Only show when the controls have scrolled off the TOP. If they're
        // still below the fold the shopper hasn't reached them yet, and a
        // bar would be noise.
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      });
    }, { rootMargin: '0px 0px -100% 0px' });

    observer.observe(anchor);

    var jump = bar.querySelector('[data-bar-jump]');
    if (jump) {
      jump.addEventListener('click', function () {
        anchor.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* --- Boot --------------------------------------------------------------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-announcement]').forEach(initAnnouncement);
    (scope || document).querySelectorAll('[data-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-product-form]').forEach(initVariants);
    (scope || document).querySelectorAll('[data-rail-scope]').forEach(initRail);
    initHotspots(scope || document);
    initProductQty(scope || document);
    initStickyBar(scope || document);
    (scope || document).querySelectorAll('[data-sticky-panel]').forEach(initSticky);
    initDrawer();
    initQuantity();
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });

  /* Re-run when a section is re-rendered inside the theme editor. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();